export default __webpack_public_path__ + "static/media/Portfolio.b16c546e.png";